/** Antd Upload getValueFromEvent - normalizes to file list */
export function normFile(e: { fileList?: unknown[] } | unknown[]): unknown[] | undefined {
  if (Array.isArray(e)) return e;
  return (e as { fileList?: unknown[] })?.fileList;
}
